export default {
    name: 'Name',
    priority: 'Priorität',
    logo: 'Logo',
    color: 'Farbe',
}